import React from 'react';
import { Button, ButtonSize, ButtonVariant } from '@benzinga/core-ui';
import i18n from '@benzinga/translate';
import { useTranslation } from 'react-i18next';

interface Props {
  link?: string;
  size?: ButtonSize;
  symbol?: string;
  onClick?: (e: Event | React.MouseEvent<HTMLButtonElement>, id: string) => void;
  variant?: ButtonVariant;
}

const CompareBrokersButton = ({
  link = 'https://www.benzinga.com/money/compare-online-brokers/',
  onClick,
  size,
  variant,
}: Props) => {
  const { t } = useTranslation('common', { i18n });

  const handleClick = (event: Event | React.MouseEvent<HTMLButtonElement>) => {
    onClick && onClick(event, 'Compare Brokers Button');
  };

  return (
    <Button
      as="a"
      className="compare-brokers-button flex justify-center w-full whitespace-nowrap"
      data-action="Compare Brokers Button Click"
      href={link}
      onClick={handleClick}
      rel="noreferrer"
      size={size}
      target="_blank"
      variant={variant || 'primary'}
    >
      {t('Buttons.compare-brokers')}
    </Button>
  );
};

export default CompareBrokersButton;
